<template>
  <div>
    <span class="display-1 pl-5" style="border-bottom: #ffca37 2px solid;"><slot></slot></span>
  </div>
</template>

<script>
export default {
name: "Header1"
}
</script>

<style scoped>

</style>